import { useNavigate } from '@tanstack/react-router'

import { SearchlightResultItemLayout } from './searchlightResultItemLayout'
import { useLocalisation } from '../../../utils/localisation'
import { SearchResponse } from '../types'
import { getEntityLink, getEntityUIDescription, isAvailableEntityType } from '../utils'

type SearchlightResultItemProps = {
  result: SearchResponse
  onSelect: () => void
}

export const SearchlightResultItem = ({ result, onSelect }: SearchlightResultItemProps) => {
  const navigate = useNavigate()
  const { translate } = useLocalisation()
  if (!isAvailableEntityType(result.entityType)) {
    return null
  }

  const { icon, prefix } = getEntityUIDescription(result.entityType)

  return (
    <SearchlightResultItemLayout
      value={result.searchContent}
      searchContent={result.searchContent}
      iconName={icon}
      prefix={prefix ? translate(prefix) : undefined}
      shipmentID={result.metadata.shipmentID}
      bookingID={result.metadata.bookingID}
      onSelect={() => {
        onSelect()
        navigate({
          to: getEntityLink(result),
        })
      }}
    />
  )
}
